import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { APPS, BUNDLE, ownsNone } from "@/lib/apps";
import { ease } from "@/lib/scroll";
import CheckoutCard from "@/components/temple/CheckoutCard";

// /initiate?product=bundle — both apps for one lifetime payment (only for people who own neither).
export default function BundleOffer() {
  const { user } = useAuth();
  if (user && !ownsNone(user)) {
    return (
      <main data-testid="bundle-offer-owned" className="min-h-[80vh] flex items-center justify-center px-5 pt-28 pb-20 text-center">
        <div className="max-w-xl">
          <h1 className="font-display text-4xl sm:text-5xl">You already hold <em className="text-[#D9B47A]">one of the apps.</em></h1>
          <p className="mt-6 text-[#CFC2B6]">The bundle is for new initiates. You can unlock the other app on its own for $297 AUD.</p>
          <Link to="/apps" data-testid="bundle-offer-apps" className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#D9B47A] text-[#0A0706] px-7 py-4 font-tt-mono text-[12px] uppercase tracking-[0.2em]">See the apps <ArrowUpRight className="w-4 h-4" /></Link>
        </div>
      </main>
    );
  }
  return (
    <main data-testid="bundle-offer" className="max-w-[1440px] mx-auto px-5 sm:px-10 pt-32 sm:pt-40 pb-28 grid lg:grid-cols-12 gap-16">
      <div className="lg:col-span-6">
        <p className="font-tt-mono text-[12px] uppercase tracking-[0.35em] text-[#E8838E]">The complete path · save {BUNDLE.save}</p>
        <h1 className="font-display text-[clamp(3rem,7vw,6.5rem)] leading-[0.95] mt-8">
          {["Both apps.", "For life."].map((w, k) => (
            <span key={w} className="block pb-[0.06em]">
              <motion.span className={`block ${k ? "italic text-[#D9B47A]" : ""}`} initial={{ y: 28, opacity: 0.35 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 1.2, delay: 0.1 + k * 0.12, ease }}>{w}</motion.span>
            </span>
          ))}
        </h1>
        <p className="mt-8 text-lg text-[#CFC2B6] max-w-xl leading-relaxed">Walk the 13 Gates to Ecstasy, then step beyond the flesh into Quantum Intimacy. Two private apps, one account, one payment.</p>
        <div className="mt-12 space-y-4">
          {[APPS.gates, APPS.quantum].map((a) => (
            <div key={a.key} data-testid={`bundle-item-${a.key}`} className="flex gap-5 border border-[#D9B47A]/20 p-5" style={{ backgroundColor: a.bg }}>
              <img src={a.icon} alt="" className="w-14 h-14 rounded-[22%] shrink-0" />
              <div className="min-w-0">
                <p className="font-display text-2xl">{a.name}</p>
                <ul className="mt-2 space-y-1.5">
                  {a.includes.map((t) => <li key={t} className="flex gap-2 text-[14px] text-[#CFC2B6]"><Check className="w-4 h-4 mt-0.5 shrink-0 text-[#E8838E]" />{t}</li>)}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:col-span-5 lg:col-start-8">
        <CheckoutCard product="bundle" already="/apps" price={BUNDLE.price} note="Both apps, one payment, yours forever. $594 when bought separately." />
      </div>
    </main>
  );
}
